import script from "./BaseStepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseStepper.vue?vue&type=script&setup=true&lang=ts"

import "./BaseStepper.vue?vue&type=style&index=0&id=0c1b7f08&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1b7f08"]])

export default __exports__